

const templatesPageStore = {
    state: () => ({
        createTemplatePanelIsOpen: false,
        updateTemplatePanelIsOpen: false,
    }),
    actions: {
        openCreateTemplatePanel: ({commit}) => {

            commit('setCreateTemplatePanelIsOpen', true)
        },
        closeCreateTemplatePanel: ({commit}) => {
            commit('setCreateTemplatePanelIsOpen', false)
        },
        openUpdateTemplatePanel: ({commit}) => {
            commit('setUpdateTemplatePanelIsOpen', true)
        },
        closeUpdateTemplatePanel: ({commit, dispatch}) => {

            commit('setUpdateTemplatePanelIsOpen', false)
        },
    },
    mutations: {
        setCreateTemplatePanelIsOpen: (state, isOpen) => {
            state.createTemplatePanelIsOpen = isOpen
        },
        setUpdateTemplatePanelIsOpen: (state, isOpen) => {
            state.updateTemplatePanelIsOpen = isOpen
        }
    },
    getters: {
        getCreateTemplatePanelIsOpen: state => {
            return state.createTemplatePanelIsOpen
        },
        getUpdateTemplatePanelIsOpen: state => {
            return state.updateTemplatePanelIsOpen
        }
    }
}

export default templatesPageStore
